import { Injectable } from '@angular/core';

export interface ClientStudiesState {
  loaded: boolean;
  religion: string | null;
  selectedCategory: string;
  categories: string[];
  featuredStudy: any;
  studies: any[];
  pagination: any;
  page: number;
}

const DEFAULT_STATE: ClientStudiesState = {
  loaded: false,
  religion: null,
  selectedCategory: 'Todos',
  categories: [],
  featuredStudy: null,
  studies: [],
  pagination: {},
  page: 1,
};

@Injectable({ providedIn: 'root' })
export class ClientStudiesStateService {
  private state: ClientStudiesState = { ...DEFAULT_STATE };

  snapshot(): ClientStudiesState {
    return { ...this.state, studies: [...this.state.studies] };
  }

  hydrate(partial: Partial<ClientStudiesState>): void {
    this.state = { ...this.state, ...partial };
  }

  reset(): void {
    this.state = { ...DEFAULT_STATE };
  }

  isStale(currentReligion: string | null): boolean {
    if (!this.state.loaded) return true;
    return this.state.religion !== currentReligion;
  }
}
